import cards from './card'
import passports from './passport'

export default {
  card: cards,
  passport: passports,
}
